import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { Amplify } from 'aws-amplify';
import { Auth } from 'aws-amplify';

// Determine if we're in production or development
const isProd = window.location.hostname !== 'localhost';
const apiEndpoint = process.env.REACT_APP_API_URL || 
  (isProd ? 'https://api.infhire.com' : 'http://localhost:3000');

// Configure Amplify using environment variables
Amplify.configure({
  Auth: {
    region: process.env.REACT_APP_AWS_REGION || 'ap-south-1',
    userPoolId: process.env.REACT_APP_AWS_USER_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_AWS_USER_POOL_WEB_CLIENT_ID,
    // Add identity pool for guest access
    identityPoolId: process.env.REACT_APP_AWS_IDENTITY_POOL_ID,
    // Mandate sign-in for all users
    mandatorySignIn: false,
    oauth: {
      domain: process.env.REACT_APP_AWS_OAUTH_DOMAIN,
      scope: ['email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
      // Both www and non-www are provided so Amplify picks the one matching
      // the current origin. Without this, users starting on infhire.com (no www)
      // store their PKCE code_verifier there, but the callback lands on
      // www.infhire.com (different origin/storage) → Cognito token exchange → 400.
      redirectSignIn: process.env.REACT_APP_REDIRECT_SIGN_IN
        || 'https://infhire.com/login,https://www.infhire.com/login',
      redirectSignOut: process.env.REACT_APP_REDIRECT_SIGN_OUT
        || 'https://infhire.com,https://www.infhire.com',
      responseType: 'code'
    }
  },
  API: {
    endpoints: [
      {
        name: 'api',
        endpoint: apiEndpoint,
        region: process.env.REACT_APP_AWS_REGION,
        custom_header: async () => {
          // Get the current session
          try {
            const session = await Auth.currentSession();
            return {
              Authorization: `Bearer ${session.getIdToken().getJwtToken()}`
            };
          } catch (e) {
            return {};
          }
        }
      }
    ]
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
